import { useEffect, useState } from 'react';
import { listContainerSizes } from '../../../reference-data.api';

/** The container sizes a trailer type can carry are chosen from the catalogue, fetched whole the first time the form opens. */
export function useContainerSizeOptions(isFormOpen: boolean) {
  const [options, setOptions] = useState<{ value: string; label: string }[] | null>(null);

  useEffect(() => {
    if (!isFormOpen || options) return;
    let cancelled = false;
    listContainerSizes()
      .then((sizes) => {
        if (!cancelled) setOptions(sizes.filter((size) => size.isActive).map((size) => ({ value: size.code, label: size.name })));
      })
      .catch(() => {
        if (!cancelled) setOptions([]);
      });
    return () => {
      cancelled = true;
    };
  }, [isFormOpen, options]);

  return options ?? [];
}
